import React from "react";
import Imgix from "react-imgix";
import Link from "gatsby-link";
import { endSlash } from "../../util/helperFunctions";

const imageSizeMap = {
  medium: "(min-width: 696px) 696px, 100vw",
  large: "100vw",
  portrait: "(min-width: 500px) 500px, 100vw"
};

const ImageBlock = ({ block, className }) => {
  return (
    <div className={`${block.format}-image-block__wrapper mt2 mb2 mt3-l`}>
      <div className={`${block.format}-image-block__image-container`}>
        {block.url ? (
          <a href={endSlash(block.url)}>
            <Imgix
              className={`${block.format}-image-block mb0`}
              src={block.image.url}
              sizes={imageSizeMap[block.format]}
              imgixParams={{
                "fp-x": block.focalPointX,
                "fp-y": block.focalPointY,
                auto: ["compress"],
                fit: "crop",
                crop: "focalpoint"
              }}
              htmlAttributes={{
                alt: block.altText
              }}
            />
          </a>
        ) : (
          <Imgix
            className={`${block.format}-image-block mb0`}
            src={block.image.url}
            sizes={imageSizeMap[block.format]}
            imgixParams={{
              "fp-x": block.focalPointX,
              "fp-y": block.focalPointY,
              auto: ["compress"],
              fit: "crop",
              crop: "focalpoint"
            }}
            htmlAttributes={{
              alt: block.altText
            }}
          />
        )}
      </div>
      {block.format != "portrait" ? (
        <p className="caption grey1">{block.caption}</p>
      ) : (
        <div>
          <p className="caption grey1">{block.caption}</p>
          <p className="caption grey2">{block.subcaption}</p>
        </div>
      )}
    </div>
  );
};

export default ImageBlock;



// WEBPACK FOOTER //
// ./src/components/Blocks/ImageBlock.js